import { IMenuStyleData, MenuItemsLayoutType, MenuLayoutType, MenuWidgetData, Orientation } from "@pageBuilder/typings";
import { CommonMenuItemsStylesRenderer } from "./items-styles-renderers/common-items-styles-renderer";
import { AlignmentUtil } from "../../../utils/alignment-util";
import { CssProperties } from "src/models/css-property";
import { ElementStyleService } from "../../../services/element-style.service";

export class MenuWidgetStyleRenderer {

    private readonly commonStyleRenderer: CommonMenuItemsStylesRenderer;

    constructor(private readonly styleService: ElementStyleService) {
        this.commonStyleRenderer = new CommonMenuItemsStylesRenderer(styleService);
    }

    public clearStylesForLayout(element: HTMLElement, previousLayoutType: MenuItemsLayoutType, style?: IMenuStyleData | null): void {
        if (style?.itemsLayoutType !== previousLayoutType) {
            this.commonStyleRenderer.clearStyles(element, previousLayoutType);
        }
    }

    public render(element: HTMLElement, style: IMenuStyleData, layoutType: MenuLayoutType | undefined): void {
        this.commonStyleRenderer.clearStyles(element);
        this.styleService.clearStyle(element, this.getListRootSelector(element.id));
        this.renderStyles(element, style, layoutType);
    }

    private renderStyles(element: HTMLElement, style: IMenuStyleData, layoutType: MenuLayoutType | undefined): void {
        const listCssProperties = new CssProperties();
        const id = element.id;

        if (style?.alignment) {
            const alignment = AlignmentUtil.correctAlignmentStyle(style?.alignment);
            if (alignment) {
                if(style?.orientation === Orientation.Horizontal) {
                    listCssProperties.add("justify-content", alignment);
                } else {
                    listCssProperties.add("align-content", alignment);
                }
            }
        }

        if (layoutType === "wrap") {
            const spaceBetweenRows = style?.spaceBetweenRows === null || style?.spaceBetweenRows === undefined
                ? MenuWidgetData.defaultMenuStyle.spaceBetweenRows
                : style.spaceBetweenRows;
            listCssProperties.add("row-gap", `${spaceBetweenRows}px`);
        }

        const columnGapValue = style?.space === null || style?.space === undefined
            ? MenuWidgetData.defaultMenuStyle.space
            : style.space;

        if (columnGapValue !== null && columnGapValue !== undefined) {
            const columnGap = style.itemsLayoutType === "divided" ? columnGapValue / 2 : columnGapValue;
            listCssProperties.add("column-gap", `${columnGap}px`);
        }

        this.styleService.setStyle(element, this.getListRootSelector(id), listCssProperties.data);
        this.commonStyleRenderer.render(element, style);
    }

    private getListRootSelector(id: string): string {
        return `#${id} ul.root`;
    }

    public getStylesSelectors(element: HTMLElement): string[] {
        return [
            ...this.commonStyleRenderer.getStylesSelectors(element),
            this.getListRootSelector(element.id),
        ];
    }

}
